'use client';

import { useEffect } from 'react';

import { Button } from '@/components/ui/button';
import { reloadOnceForChunkLoad } from '@/lib/errors/chunk-load-recovery';
import { reportClientError } from '@/lib/errors/report-client-error';

export default function AccountError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (reloadOnceForChunkLoad(error)) {
      return;
    }
    reportClientError({
      message: error.message,
      digest: error.digest,
      route: '/account',
    });
  }, [error]);

  return (
    <main className="mx-auto max-w-lg space-y-4 px-4 py-12 text-center">
      <h1 className="text-xl font-semibold">Account error</h1>
      <p className="text-sm text-muted-foreground">Unable to load this account page.</p>
      <Button onClick={() => reset()}>Try again</Button>
    </main>
  );
}
